import React from "react";
import { FormGroup } from "../../../components/form/models/models";
import * as Yup from "yup";

export const providingInclusiveKindergartenEnvironmentForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "teamsConfidenceInInclusiveEnvironment",
      fieldType: "textarea",
      label: "What is the kindergarten team's experience and confidence in providing an inclusive learning environment?",
      validation: Yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      fieldType: "dropdown",
      key: "teacherExperience",
      label: "Teacher years of experience",
      props: {
        options: [
          {
            label: "Graduate (0 - 2 yrs)",
            value: 0,
          },
          {
            label: "Early Career (3 - 5 yrs)",
            value: 1,
          },
          {
            label: "Mid Career (6 - 10 yrs)",
            value: 2,
          },
          {
            label: "Experienced (10+ yrs)",
            value: 3,
          },
          {
            label: "Information Not Provided",
            value: 4,
          },
        ],
      },
      validation: Yup.string().required("A response is required"),
    },
    {
      type: "field",
      fieldType: "radio",
      key: "accessedSupportFromKis",
      label: "Has the early childhood teacher previously accessed support from the KIS program?",
      validation: Yup.string().required("A response is required"),
      props: {
        options: [
          {
            label: "Yes",
            value: 1,
          },
          {
            label: "No",
            value: 0,
          },
        ],
      },
    },
    {
      type: "field",
      fieldType: "number",
      key: "kisSupportYear",
      label: "If yes, in what year?",
      extendedLabel: "Please record the most recent year that the teacher accessed KIS support",
      validation: Yup.number()
        .required("A response is required")
        .test("maxDigits", "Please enter a valid year", (value) => {
          return String(value).length === 4;
        })
        .min(new Date().getFullYear() - 10, "The date cannot be more than 10 years ago")
        .max(new Date().getFullYear(), "The date cannot be in the future"),
      hideExpression: (formContext, values, model) => model.accessedSupportFromKis != 1,
    },
    {
      type: "formGroup",
      label: "What support was provided? Select all that apply.",
      key: "whatSupport",
      fields: [
        {
          type: "field",
          fieldType: "checkbox",
          key: "specialistConsultancy",
          label: "Specialist consultancy",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "additionalAssistant",
          label: "Additional assistant",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "specialistTraining",
          label: "Specialist training",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "minorBuildingModifications",
          label: "Minor building modifications",
        },
      ],
      test: [
        "oneSelected",
        "A response is required",
        (value) => value.specialistConsultancy || value.additionalAssistant || value.specialistTraining || value.minorBuildingModifications,
      ],
      hideExpression: (formContext, values, model) => model.accessedSupportFromKis != 1,
    },
    {
      type: "field",
      fieldType: "textarea",
      label:
        "Please briefly describe the structure of the kindergarten program including how the program promotes learning experiences, interactions and participation building on children’s strengths.",
      extendedLabel: "Please include information in this section about the number and types of transitions that occur during a typical day.",

      key: "describeKindergartenLearningExperiences",
      validation: Yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      fieldType: "textarea",
      label: "Group dynamics: describe the specific additional support needed by other individual children in the group",
      extendedLabel: (
        <>
          If children in the group require specific additional supports <strong>beyond what is age-appropriate and usual in a kinder setting</strong>,
          these should be clearly articulated. You can refer to child A, child B etc to make it clear to the assessor what the
          diagnosis/disability/suspected diagnosis/disability is and the additional supports required for each child.
          <br /> <br />
          Please note that risk factors/vulnerabilities alone (e.g. child is from a family with separated parents, children in the group are from a
          culturally and linguistically diverse background) <strong>should not be included unless specific additional supports are required.</strong>
        </>
      ),
      key: "groupDynamics",
      validation: Yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      fieldType: "textarea",
      key: "additionalKinderEnvironmentInfo",
      label:
        "If there is any other information about the operation of the kindergarten program or environment that is important for the assessment team to understand, please include it here.",
    },
  ],
};
